/**
 * Logistics Module - Parent Component
 * Version: 1.0.0
 * Description:
 *   Main entry point for the Logistics Delivery system.
 *   Contains routing for Dashboard, Database, Routing, GPS, and Drivers.
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import LogisticsDashboard from './LogisticsDashboard';
import LogisticsDatabase from './LogisticsDatabase';
import LogisticsRouting from './LogisticsRouting';
import LogisticsGPS from './LogisticsGPS';
import LogisticsDrivers from './LogisticsDrivers';

export default function LogisticsModule() {
  return (
    <Routes>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<LogisticsDashboard />} />
      <Route path="database" element={<LogisticsDatabase />} />
      <Route path="routing" element={<LogisticsRouting />} />
      <Route path="gps" element={<LogisticsGPS />} />
      <Route path="drivers" element={<LogisticsDrivers />} />
    </Routes>
  );
}
